/**
 * 有効期限種別
 */
export enum ExpirationType {
  // 有効期限内
  TYPE_CONTRACT = 1,
  // 猶予期間
  TYPE_GRACE = 2,
  // 有効期限切れ
  TYPE_EXPIRED = 3,
  // 有効期限なし
  TYPE_NON = 4
}

/**
 * 有効期限チェック処理
 * @param now 現在日時
 * @param expiration 有効期限
 * @param gracedays 猶予日数
 * @returns 有効期限種別
 */
export const checkExpirationDatetime = (
  now: number,
  expiration: string | null,
  gracedays: number | null
) => {
  if (expiration == null || gracedays == null) {
    // 有効期限又は猶予日数がnullの場合は有効期限なしと判断
    return ExpirationType.TYPE_NON;
  }
  // 有効期限のみでチェック
  const expirationDate = new Date(expiration);
  //console.log('expirationDate.getTime() = ' + expirationDate.getTime());
  if (expirationDate.getTime() >= now) {
    // 現在時刻の方が有効期限より前の場合は有効期限内と判断
    return ExpirationType.TYPE_CONTRACT;
  }
  // 有効期限＋猶予期間でチェック
  const limitDate = new Date(
    expirationDate.setDate(expirationDate.getDate() + gracedays)
  );
  if (now > limitDate.getTime()) {
    // 現在時刻の方が有効期限+猶予日時より後の場合は有効期限切れと判断
    return ExpirationType.TYPE_EXPIRED;
  } else {
    // 上記以外の場合は猶予期間内と判断
    return ExpirationType.TYPE_GRACE;
  }
};
